import { render, staticRenderFns } from "./AddPaymentTermPage.vue?vue&type=template&id=0168252f"
import script from "./AddPaymentTermPage.vue?vue&type=script&lang=js"
export * from "./AddPaymentTermPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports